module.exports = __webpack_public_path__ + "static/cadogan-small-square-8cf7b600c098d688735db754d8c64a78.jpg";